import type { RouteRecordRaw } from 'vue-router';

/**
 * The page owns its copy: `loadFeatureI18n` reads this glob off `meta.i18n` and merges the
 * bundle before the route renders (STRUCTURE.md, i18n rule). `import.meta.glob` resolves
 * relative to THIS file, so it must stay here and not move into `router/routes.ts`.
 */
const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

/**
 * Front Desk board (`/front-desk`). Same guards as every other post-login screen — signed in,
 * one store selected (HC-1, AC13); the turn tracker's route record is the shape this follows.
 * Checkout owns a separate screen folder and route; both records remain flat in MainLayout.
 *
 * Nav entries: the board is the list of customers waiting to pay (STORY-932, QĐ 35), so the
 * footer opens it — the `us` "Customer Check out" tab (e-539) and the `au` Home tab — and so does
 * every in-app entry that opens that list. The old "reached by URL only" rule (K-4, PRD AC1) was
 * lifted by PRD STORY-932 (table of replaced parent ACs: AC17 sc. 2, Non-goals 1, G4 / BO-4).
 */
export const frontDeskRoutes = {
  name: 'front-desk',
  path: 'front-desk',
  component: () => import('./FrontDesk.vue'),
  meta: { i18n, titleKey: 'frontDesk.metaTitle' },
} satisfies RouteRecordRaw;
